export const inputgroup = {
  root: {
    class: ['group/input-group', 'flex items-stretch', 'w-full'],
  },
};
